import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import LegalSearch from "./pages/LegalSearch";
import LegalSearchResults from "./pages/LegalSearchResults";
import DiscussionForum from "./pages/DiscussionForum";
import Activity from "./pages/Activity";
import SSOLogin from "./pages/SSOLogin";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
         
          <Route path="/login" element={<SSOLogin />} />
          
          <Route path="/*" element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/legal-search" element={<LegalSearch />} />
                  <Route
                    path="/legal-search-results"
                    element={<LegalSearchResults />}
                  />
                  <Route path="/discussion-forum" element={<DiscussionForum />} />
                  <Route path="/activity" element={<Activity />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
